import React, { useCallback, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import api from '../../services/api';

import getValidationErrors from '../../utils/getValidationErrors';
import { useAlert } from '../../hooks/alert';

import Input from '../../components/Input';

const LoginForget: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const [loading, setLoading] = useState(false);

  const { showAlert } = useAlert();
  const history = useHistory();

  const handleSubmit = useCallback(
    async (data: object) => {
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Digite seu e-mail')
            .email('Digite um e-mail válido'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('login-forget', data);

        showAlert({
          type: 'success',
          title: 'E-mail enviado',
          description:
            'Um e-mail foi encaminhado com a sua nova senha de acesso.',
        });

        history.push('login');
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        } else {
          showAlert({
            type: 'error',
            title: 'E-mail não encontrado',
            description:
              'Seu e-mail não foi localizado em nossa base de dados.',
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [history, showAlert],
  );

  return (
    <>
      <Form onSubmit={handleSubmit} ref={formRef}>
        <h5 className="spacer">ESQUECI MINHA SENHA</h5>

        <p>
          Lorem ipsum dolor sit amet, qui minim labore adipisicing minim sint
          cillum sint consectetur cupidatat.
        </p>

        <div className="spacer" />

        <div className="row">
          <div className="col-lg-6 offset-lg-3 offset-0">
            <div className="form-group">
              <label htmlFor="email">E-MAIL</label>
              <Input
                name="email"
                type="text"
                className="form-control"
                id="email"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 offset-lg-3 offset-0">
            <div className="row">
              <div className="col-12 col-sm-6">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? 'CARREGANDO...' : 'RECUPERAR'}
                </button>
              </div>
              <div className="col-12 col-sm-6 d-flex align-items-center align-items-sm-end justify-content-center flex-column">
                <div className="p-4 p-sm-0">
                  <Link to="login">Voltar para tela de acesso</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};

export default LoginForget;
